import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { AssessementContext } from "../../AssessmentContext";
import { useContext } from "react";
import { api } from "../../../../../api";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import ScaleLoader_ from "../../components/ScaleLoader";
import toast from "react-hot-toast";
import { useCustomToast } from "../../../../../components/customtoast/CustomToastProvider";
import { exams } from "../../../../../api/exams";
import { updateAnswers } from "../view-assessement/components/UpcomingAssessment";
import { useSelector } from "react-redux";
import { exams as examsApi } from "../../../../../api/exams";
import { toPlainAnwers } from "../candidate-assessment/components/utils/functions";
import { decryptQuestionResponse } from "../candidate-assessment/components/utils/decryptData";
import { useTranslation } from "react-i18next";
import { useMediaPipe } from "../../../../../hooks/useMediaPipe";
import { exitFullScreen } from "../candidate-assessment/components/utils/functions";
import { getPipelineEndsAt, isStartWindowClosedError, setPipelineEndsAt } from "../../../../../utils/pipelineWindow";
const Instructions = ({ start, restart, pause }) => {

  const { assessment, setAssessment } = useContext(AssessementContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation()
  const customToast = useCustomToast();
  const user = JSON.parse(sessionStorage.getItem('user'))
  const time_left = parseInt(window.sessionStorage.getItem("time_left"));
  const duration = parseInt(window.sessionStorage.getItem("duration"));
  const currentLanguage = useSelector((state) => state.traslation.language);
  const last_question_viewed = parseInt(
    sessionStorage.getItem("last_question_viewed")
  );
  const time_in_minutes = (time) => Math.floor(time / 60);
  const { questionSavedAnswers, questionsDuration, examQuestions } =
    useSelector((state) => state.candidateExam);

  // Proctoring pre-check
  const videoRef = React.useRef(null);
  const activeExam = JSON.parse(window.sessionStorage.getItem("active-assessment") || '{}');
  const allowProctoring = Boolean(activeExam?.allow_proctoring);
  const { faceStatus } = useMediaPipe(videoRef, allowProctoring);
  const lastToastTimeRef = React.useRef(0);
  const TOAST_COOLDOWN = 10000; // 10 seconds
  // Expiry timestamp the timer was started with, so it can be corrected from the initiate-questions response
  const timerExpiryRef = React.useRef(null);
  const [startWindowClosedMessage, setStartWindowClosedMessage] = React.useState(null);

  React.useEffect(() => {
    // Only monitor if proctoring is enabled for this exam
    if (!allowProctoring) return;

    // Standard camera stream initialization
    let stream = null;
    (async () => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video: true });
        if (videoRef.current) videoRef.current.srcObject = stream;
      } catch (err) {
        console.error("Camera check error:", err);
      }
    })();

    return () => {
      stream?.getTracks().forEach(t => t.stop());
    };
  }, []);

  React.useEffect(() => {
    const now = Date.now();
    if (now - lastToastTimeRef.current < TOAST_COOLDOWN) return;
    if (!allowProctoring) return;

    if (faceStatus.flags.includes("camera_blocked")) {
      customToast.error("Camera is blocked or turned off! Please ensure your camera is active.");
      lastToastTimeRef.current = now;
    } else if (faceStatus.flags.includes("camera_obstructed") || faceStatus.flags.includes("camera_static_or_covered")) {
      customToast.error("Camera view is obstructed or frozen. Please clear the camera.");
      lastToastTimeRef.current = now;
    } else if (faceStatus.flags.includes("too_dark")) {
      customToast.error("Your environment is too dark. Please improve lighting.");
      lastToastTimeRef.current = now;
    }
  }, [faceStatus.flags, customToast]);

  const unsupportedActions = [
    t('minimize-browser'),
    t('resize-browser'),
    t('open-new-tab'),
    t('open-new-program'),
    t('ctrl-c'),
    t('ctrl-v'),
    t('print-screen'),
    t('f12'),
  ];

  const updateAnswersMutation = useMutation(examsApi.updateAnswersv2, {
    onSuccess: (response) => {
      dispatch(flushSubmittedAnswers());
      refetch();
    },
  });

  const logAssessmentMutation = useMutation(exams.logAssessment)

  const getQuestionsmutation = useMutation(exams.getExamQuestionsv2, {
    onSuccess: async (data) => {
      let response = data
      const exam = JSON.parse(sessionStorage.getItem("active-assessment"));
      const payload = {
        user_id: user?.user?.user_id,
        user_exam_id: exam?.user_exam_id,
        attempt: (sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ?
          parseInt(sessionStorage.getItem('attempt_count'))
          : exam?.current_attempt,
        action_type: "initiate assessment",
        request_payload: null,
        response_payload: { message: 'Questions fetched successfully', status: 200 }
      }
      logAssessmentMutation.mutate({ payload })


      //const response = await decryptQuestionResponse({ encryptedData, ivHex, secretKeyHex,})
      let questionResponse = data?.data?.questions //response?.questions?.length ? response?.questions : [];  
      //console.log("questionResponse", questionResponse, { data });
      if (sessionStorage.getItem("rejoinUser") === '1') {
        // console.log({ message: 'rejoin user =====1' });

        sessionStorage.setItem("rejoinUser", '0')
        //compare between current question and prevoius saved questions
        const questions = questionResponse?.filter((q) => {
          return q?.answers?.some((ans) => ans?.status === true);
        });
        // console.log("questions", questions);
        if (examQuestions?.length) {
          if (questions?.length === 0) {
            //sync client answers
            const client_answers = toPlainAnwers(examQuestions);
            updateAnswers({
              answers: client_answers, questionsDuration,
              questions: questionResponse, updateAnswersMutation
            });
          } else {
            //check for unsync questions and retry submitting
            const client_answers = toPlainAnwers(examQuestions);
            const server_answers = toPlainAnwers(questions);
            const unsynced_answers = client_answers.filter((client_answer) => {
              return !server_answers.some((server_answer) => {
                return (
                  client_answer.question_id === server_answer.question_id &&
                  client_answer.answer_id === server_answer.answer_id
                );
              });
            });
            //update answers
            if (unsynced_answers?.length) {
              updateAnswers({
                answers: unsynced_answers, questionsDuration,
                questions: questionResponse, updateAnswersMutation
              });
            }
          }
        }
        return
      }
      else {
        // console.log({ questionResponse, m: '! rejoin user' });
        // The server caps a fresh start at the pipeline end: start the timer from its time_left (seconds)
        if (data?.data?.pipeline_ends_at) setPipelineEndsAt(data?.data?.pipeline_ends_at);
        let expiry = timerExpiryRef.current;
        if (Number.isFinite(data?.data?.time_left)) {
          expiry = new Date().getTime() + data.data.time_left * 1000;
        }
        const pipelineEndsAt = getPipelineEndsAt();
        if (pipelineEndsAt && (!expiry || pipelineEndsAt < expiry)) expiry = pipelineEndsAt;
        if (expiry && expiry !== timerExpiryRef.current) restart(expiry);

        if (!questionResponse?.length) {
          toast.error(t('error-no-question'))
        }
        else {
          const UnsyncQuestions = localStorage.getItem(`examQuestions-${JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id
            }`)

          //  console.log({ UnsyncQuestions });

          if (UnsyncQuestions) {
            const unsyncQuestionsParsed = JSON.parse(UnsyncQuestions)
            if (unsyncQuestionsParsed?.length) {
              const updatedAllQuestions = questionResponse.map(question => {
                const attemptedQ = unsyncQuestionsParsed?.find(aq => aq.id === question.id);
                if (!attemptedQ) return question;
                // Return updated question with attempt status
                return {
                  ...question,
                  answers: question?.answers?.map(answer => {
                    const attemptedAnswer = attemptedQ.answers.find(aa => aa.id === answer.id);
                    return attemptedAnswer ? { ...answer, status: attemptedAnswer.status } : answer;
                  })
                };
              });
              sessionStorage.setItem(`unsyncQuestionsParsed`, JSON.stringify(unsyncQuestionsParsed))
              //temporary disbled for now
              questionResponse = updatedAllQuestions
            }
          }
          // console.log({ questionResponse, UnsyncQuestions }, 'final');

          // return
          setAssessment({
            ...assessment,
            assessements: { questions: questionResponse },
            activeQuestion: { ...questionResponse[0] },
            questionType: questionResponse[0]?.type,
            questionNumber: JSON.parse(UnsyncQuestions)?.length ?
              JSON.parse(UnsyncQuestions || '[{}]')?.length - 1
              : 0,
            activeAssessment: {
              ...JSON.parse(window.sessionStorage.getItem("active-assessment")),
            },
          });
          setTimeout(
            () => navigate("/candidate/assessments/candidate-assessment"),
            100
          );
        }
      }
    },
    onError: (error) => {
      const { response } = error;
      const exam = JSON.parse(sessionStorage.getItem("active-assessment"));
      const payload = {
        user_id: user?.user?.user_id,
        user_exam_id: exam?.user_exam_id,
        attempt: (sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ?
          parseInt(sessionStorage.getItem('attempt_count'))
          : exam?.current_attempt,
        action_type: "initiate assessment",
        request_payload: null,
        response_payload: {
          message: response?.data?.message ||
            'There is an issue fetching questions, no response message from the server..',
          status: response?.response?.status
        }
      }
      logAssessmentMutation.mutate({ payload })
      toast.remove();
      if (isStartWindowClosedError(error)) {
        // Too close to (or past) the pipeline end: undo the exam setup and block the start
        pause?.();
        setAssessment({ ...assessment, startAssessment: false });
        sessionStorage.setItem("full_screen_mode", 0);
        exitFullScreen();
        document.querySelector("#sidebar").style.display = "";
        const mobileNavbar = document.querySelector(".mobile-navbar");
        if (mobileNavbar) mobileNavbar.style.display = "";
        setStartWindowClosedMessage(response?.data?.message);
        return;
      }
      customToast.error(response?.data?.message);
    },
  });

  React.useEffect(() => {
    const container = document.querySelector(`#parent-container`);
    container.scrollTo({ top: 0 });
    sessionStorage.setItem("exam-submit-status", 0);
    sessionStorage.setItem("device-width", window.innerWidth);
    sessionStorage.setItem("device-height", window.innerHeight);
    setAssessment({ ...assessment, isAutomove: false });
    // validate and sync if user is coming from rejoin page
    if (sessionStorage.getItem("rejoinUser") === '1') {
      getQuestionsmutation.mutate({
        userId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
        examId: sessionStorage.getItem("active-exam-id"),
        userExamId: window.sessionStorage.getItem("active-assessment-user-id"),
        assessmentId: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id,
        showOnlyQuestions: true,
        language: currentLanguage,
        number_of_attempts: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt || sessionStorage.getItem('attempt_count'),
        //(sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ?
        // parseInt(sessionStorage.getItem('attempt_count'))
        // : JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt,
        //level: sessionStorage.getItem("level") || 'easy',
        //switchQuestion: true
      });
    };
  }, []);

  const startAssessment = () => {
    if (!window.navigator.onLine) {
      return customToast.error('internet disconnected (no connection) please check your internet connection and try again')
    }
    if (time_left !== duration && time_left !== null && !isNaN(time_left)) {
      timerExpiryRef.current = new Date().getTime() + time_left * 60 * 1000;
    } else {
      timerExpiryRef.current = new Date().getTime() + duration * 60 * 1000;
    }
    restart(timerExpiryRef.current);

    setAssessment({ ...assessment, startAssessment: true });
    sessionStorage.setItem("full_screen_mode", 1);
    const element = document.documentElement; // Get the root element of the document
    const isTestEnvironment = window.Cypress
    if (element.requestFullscreen && !isTestEnvironment) {
      element.requestFullscreen();
    }
    //hide sidebar and
    // setIsOpen(false)
    document.querySelector("#sidebar").style.display = "none";
    //hide navbar in mobile devices
    if (window.matchMedia("(max-width: 700px)").matches) {
      document.querySelector(".mobile-navbar").style.display = "none";
    }
    const UnsyncQuestions = localStorage.getItem(`examQuestions-${JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id
      }`)

    const unsyncQuestionsParsed = JSON.parse(UnsyncQuestions || '{}')
    const hasStarted = JSON.parse(window.sessionStorage.getItem("active-assessment"))?.started_at
    setTimeout(() => {
      getQuestionsmutation.mutate({
        ignoreCache: (hasStarted && !unsyncQuestionsParsed?.length) ? true : false,
        userId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
        examId: sessionStorage.getItem("active-exam-id"),
        userExamId: window.sessionStorage.getItem("active-assessment-user-id"),
        showOnlyQuestions: false,
        assessmentId: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.assessment_id,
        language: currentLanguage,
        number_of_attempts: JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt,
        //(sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ?
        // parseInt(sessionStorage.getItem('attempt_count'))
        // : JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt,
        // level: sessionStorage.getItem("level") || 'easy',
        // switchQuestion: true
      });
    }, 1000);
  };

  const brandedClient = JSON.parse(sessionStorage.getItem("client") || '{}');

  return (
    <div>
      {" "}
      {getQuestionsmutation?.isLoading ? <ScaleLoader_ /> : null}
      <section className="jumbotron bg-white p-4">
        {
          //<Link
          //   to={"/candidate/assessments/view-assessments"}
          //   className="text-lg"
          // >
          //   {t('exam')}
          // </Link>
          // <span className="mx-2">/</span>
          // <Link
          //   to={"/candidate/assessments/instructions"}
          //   className="text-lg text-customGreen"
          // >
          //   {t('instructions')}
          // </Link>
        }
        <div style={{ backgroundColor: brandedClient?.primary_colour || undefined }} className="mt-8 py-12 bg-darkBlue px-5 text-white rounded-lg">
          <h5 className="text-2xl flex">
            {
              assessment?.activeAssessment?.assessment_title
              || JSON.parse(window.sessionStorage.getItem("active-assessment"))?.title
            }
          </h5>
          <p className="text-[12px]">{t('attempt-all-questions')}</p>
          <div className="mt-4 bg-white py-4 rounded-lg text-gray-900 px-4 flex justify-between">
            <span>
              {t('total-questions')}{" "}
              {sessionStorage.getItem("ql")}
            </span>
            <span className="text-xl flex items-center">
              <i className="text-2xl bi bi-clock-history mr-2"></i>{" "}
              {duration}
              {t('minutes')}
            </span>
          </div>
        </div>
        <div className="mt-5">
          <h5 className="text-2xl">
            {" "}
            <strong className="text-2xl">{t('instructions')}:</strong>{" "}
          </h5>
          <h4 className="text-lg text-red-500">
            {t('read-instructions')}
          </h4>
          <p className="mt-3 text-lg">
            {t('full-screen')}
          </p>
          <p className="mt-3 text-lg">
            1.&nbsp; {t('frozen-screen')} {t('recommendation')}
          </p>
          <p className="mt-3 text-lg">
            2. &nbsp;  {t('screen-not-sized')} {t('resize-or-switch')}
          </p>
          <p className="mt-3 text-lg">
            3. &nbsp;  {t('assessment-timer')}
          </p>
          <p className="mt-3 text-lg">
            4. &nbsp;  {t('optimal-experience')}
          </p>
          <p className="mt-3 text-lg">
            5. &nbsp;  {t('flag-question')}
          </p>
          <p className="mt-3 text-lg">
            6. &nbsp; {t('unusual-activities')}
          </p>
          <h4 className="text-2xl text-red-500 mt-5">
            {t('secure-assessment-advice')}
          </h4>
          <p className="mt-1 text-lg">
            {t('secure-assessment-warning')}
          </p>
          <strong className="text-xl block my-3">
            {t('unsupported-actions')}:
          </strong>
          <section className='bg-white p-5 mt-5 text-xl rounded-lg'>
            {t('provisional-score-notice')}
          </section>
          <ul className="py-5 px-3 bg-red-100 border border-red-500 rounded-lg">
            {unsupportedActions.map((unsupportedAction, id) => {
              return (
                <li
                  key={id}
                  className="mt-3 text-lg capitalize text-red-500 flex items-center"
                >
                  <span className="text-xl bi bi-exclamation-triangle ml-3 mr-2"></span>
                  {unsupportedAction}
                </li>
              );
            })}
          </ul>
          <div className="mt-8 flex justify-end mb-5">
            <button
              onClick={startAssessment}
              disabled={getQuestionsmutation.isLoading}
              className="border flex justify-center bg-red-500 text-white py-3 block  w-[300px] rounded-lg"
            >
              <span
                className="text-lg text-center"
                data-testid="assessment-instruction"
              >
                {" "}
                {t('ok-understand')}{" "}
              </span>
            </button>
          </div>
        </div>
      </section>
      {startWindowClosedMessage && (
        <div className="h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.3)] fixed top-0 left-0" style={{ zIndex: 9000000 }}>
          <div className="w-full h-full flex items-center justify-center">
            <div className="bg-white w-[94%] md:w-[35%] rounded-lg">
              <h5 className="py-5 px-3 shadow-lg text-xl">Assessment closed</h5>
              <div className="w-[80%] mx-auto my-6">
                <p className="flex justify-center">
                  <span className="text-[80px] bi bi-clock-history text-red-500"></span>
                </p>
                <p className="text-lg text-center mt-3">{startWindowClosedMessage}</p>
              </div>
              <div className="flex justify-center border-t border-gray-200 px-3 py-3">
                <button
                  onClick={() => navigate(-1)}
                  className="bg-primary py-3 px-10 rounded-lg text-white text-lg"
                >
                  Back to assessments
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Hidden video element for pre-assessment proctoring check */}
      <video ref={videoRef} autoPlay muted playsInline style={{ display: 'none' }} />
    </div>
  );
};

export default Instructions;
